$(document).ready(function () {
  $(".fancybox").fancybox({
    openEffect: "elastic",
    closeEffect: "elastic",
    helpers: {
      title: { type: "inside" },
      media: {},
      overlay: { locked: false },
    },
  });
});
function getUserTimeOffset() {
  return new Date().getTimezoneOffset();
}
